import { render, staticRenderFns } from "./DimensionsWizard.vue?vue&type=template&id=49fae294&scoped=true"
import script from "./DimensionsWizard.vue?vue&type=script&lang=ts"
export * from "./DimensionsWizard.vue?vue&type=script&lang=ts"
import style0 from "./DimensionsWizard.vue?vue&type=style&index=0&id=49fae294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fae294",
  null
  
)

export default component.exports